import { render, staticRenderFns } from "./EditRootUserModal.vue?vue&type=template&id=028518ce&scoped=true"
import script from "./EditRootUserModal.vue?vue&type=script&lang=js"
export * from "./EditRootUserModal.vue?vue&type=script&lang=js"
import style0 from "./EditRootUserModal.vue?vue&type=style&index=0&id=028518ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028518ce",
  null
  
)

export default component.exports